import React from "react";
import { useNavigate } from "react-router-dom";

export const ProductCardSkeleton = () => {
  return (
    <div
      className="
        bg-[#F3F3F3]
        rounded-lg
        p-4
        w-[230px] md:w-[220px]
        flex-shrink-0
        animate-pulse
      "
    >
      {/* IMAGE */}
      <div className="w-full h-[250px] md:h-[250px] bg-gray-300 rounded-sm" />

      {/* BRAND */}
      <div className="h-3 w-16 bg-gray-300 rounded mt-3" />

      {/* PRODUCT NAME */}
      <div className="h-4 w-full bg-gray-300 rounded mt-2" />
      <div className="h-4 w-3/4 bg-gray-300 rounded mt-1" />

      {/* RATING */}
      <div className="h-5 w-24 bg-gray-300 rounded mt-2" />

      {/* PRICE */}
      <div className="flex gap-2 mt-3">
        <div className="h-5 w-16 bg-gray-300 rounded" />
        <div className="h-4 w-12 bg-gray-300 rounded" />
      </div>

      {/* BUTTON */}
      <div className="h-9 w-full bg-gray-300 rounded mt-4" />
    </div>
  );
};

const ProductCard = ({ product, showBuyNow = false }) => {
  const navigate = useNavigate();

  const handleCardClick = () => {
    navigate(`/view-one-product/${product._id}`);
  };

  const handleBuyNow = (e) => {
    e.stopPropagation();
    navigate(`/view-one-product/${product._id}?buyNow=true`);
  };

  const {
    brand = "",
    productName = "",
    images = [],
    price = 0,
    mrp = 0,
    ratings = { avgRating: 0, totalReviews: 0 }
  } = product || {};

  // ✅ SAFE DISCOUNT CALCULATION
  const discount =
    mrp > 0 && price > 0
      ? Math.round(((mrp - price) / mrp) * 100)
      : 0;

  const imageUrl =
    images?.[0] ||
    "https://via.placeholder.com/300x400?text=No+Image";

  return (
    <div
      onClick={handleCardClick}
      className="
        bg-[#F3F3F3]
        rounded-lg
        shadow-sm
        transition
        cursor-pointer
        p-4
        w-[230px] md:w-[220px]
        flex-shrink-0
        snap-start
      "
    >
      {/* IMAGE */}
      <div className="w-full h-[230px] md:h-[230px]  rounded-sm overflow-hidden">
        <img
          src={imageUrl}
          alt={productName}
          className="w-full h-full object-fill"
        />
      </div>

      {/* DETAILS */}
      <div className="mt-3">
        <h4 className="text-sm font-medium uppercase text-[#191C1F] truncate w-30">
          {brand}
        </h4>

        <p className="text-sm font-normal text-[#191C1F] line-clamp-2 mt-1 min-h-[36px]">
          {productName}
        </p>

        {/* RATING (STATIC for now) */}
        <div className="flex items-center gap-1 mt-1">
          <span className="bg-[#007BFF] text-white text-xs px-1.5 py-0.5 rounded-md">
            {ratings.avgRating} <span className="text-[#FA8232]">★</span> ({ratings.totalReviews})
          </span>
        </div>

        {/* PRICE */}
        <div className="flex items-center gap-2 mt-2">
          <span className="text-base font-semibold text-[#222222]">
            ₹{price}
          </span>

          {mrp > price && (
            <>
              <span className="text-sm line-through text-[#5F6C72]">
                ₹{mrp}
              </span>
              <span className="text-xs text-[#007BFF] font-medium">
                {discount}% Off
              </span>
            </>
          )}
        </div>

        {/* BUY NOW */}
        {showBuyNow && (
          <button
            onClick={handleBuyNow}
            className="
              w-full mt-3
              bg-[#007BFF]
              text-white
              py-1.5
              rounded-md
              text-sm
              font-medium
              hover:bg-blue-700
            "
          >
            Buy Now
          </button>
        )}
      </div>
    </div>
  );
};

export default ProductCard;
